import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";

interface PageContextProps {
  pagetype: string;
  currentLink: string;
  setCurrentLink?: (k: string) => void;
  goSetting?: () => void;
  leaveSetting?: () => void;
}

export const pageContext = React.createContext<PageContextProps>({
  pagetype: "",
  currentLink: "",
});

export const usePage = () => {
  return React.useContext(pageContext);
};

export const ProviderPage = (p: any) => {
  const page = useProviderPage();
  return <pageContext.Provider value={page}>{p.children}</pageContext.Provider>;
};

export const useProviderPage = () => {
  const history = useHistory();
  const location = useLocation();
  const [pagetype, setPagetype] = React.useState("");
  const [prevlink, setPrevLink] = React.useState("");
  const [currentLink, setCurrentLink] = React.useState("/");

  const goSetting = () => {
    const current = location.pathname;
    setPrevLink(current);
    setPagetype("setting");
    history.replace("/setting/normal");
  };
  const leaveSetting = () => {
    setPagetype("main");
    history.push(prevlink);
  };

  React.useEffect(() => {
    const { pathname } = location;
    if (/login|reg|losepass/.test(pathname)) {
      setCurrentLink("/login");
      setPagetype("main");
    } else if (/main/.test(pathname) || pathname === "/") {
      setCurrentLink(pathname);
      if (pagetype !== "main") {
        setPagetype("main");
      }
    } else if (/setting/.test(pathname)) {
      setCurrentLink(pathname);
      if (pagetype !== "setting") {
        setPagetype("setting");
      }
    } else {
      setCurrentLink(pathname);
      setPagetype("");
    }
  }, [location, pagetype]);

  // React.useEffect(() => {
  //   const { pathname } = location;
  //   if (pathname.indexOf("main") >= 0) {
  //     if (pagetype !== "main") {
  //       setPagetype("main");
  //     }
  //   } else if (pathname.indexOf("setting") >= 0) {
  //     if (pagetype !== "setting") {
  //       setPagetype("setting");
  //     }
  //   } else {
  //     setPagetype("");
  //   }
  // }, []);

  return {
    pagetype,
    currentLink,
    goSetting,
    leaveSetting,
  };
};
